// extracted by mini-css-extract-plugin
export var container = "_4t-0";
export var disabled = "_4t-4";
export var fullWidth = "_4t-3";
export var lined = "_4t-1";
export var selected = "_4t-5";
export var tab = "_4t-2";